<div class="wrap {{ type }}">
  <app-svg-icon
    class="icon"
    name="info"
    [color]="iconColorMap[type]"
  ></app-svg-icon>
  <div class="header">{{ header }}</div>
  <div class="message">{{ message }}</div>
  <app-action-button
    (click)="modalService.dismiss()"
    [label]="'OK'"
  ></app-action-button>
</div>
